import { createAsyncThunk } from '@reduxjs/toolkit';

import api, { AxiosError } from 'api';

export const loadDocComments = createAsyncThunk(
    'GET/document_comments/{doc_id}',
    async (docID: string, { rejectWithValue }) => {
        try {
            return await api.documentComments.get(docID);
        } catch (e) {
            return rejectWithValue((e as AxiosError).response?.data);
        }
    }
);

export const createComment = createAsyncThunk(
    `POST/document_comments/\${doc_id}`,
    async (
        { docID, payload }: { docID: string; payload: { text: string } },
        { rejectWithValue }
    ) => {
        try {
            return await api.documentComments.post(docID, payload);
        } catch (e) {
            return rejectWithValue((e as AxiosError).response?.data);
        }
    }
);

export const updateComment = createAsyncThunk(
    `PUT/document_comments/\${doc_id}/{comment_id}`,
    async (
        {
            docID,
            commentID,
            payload,
        }: { docID: string; commentID: string; payload: { text: string } },
        { rejectWithValue }
    ) => {
        try {
            return await api.documentComments.put(docID, commentID, payload);
        } catch (e) {
            return rejectWithValue((e as AxiosError).response?.data);
        }
    }
);

export const deleteComment = createAsyncThunk(
    `DELETE/document_comments/\${doc_id}/{comment_id}`,
    async ({ docID, commentID }: { docID: string; commentID: string }, { rejectWithValue }) => {
        try {
            return await api.documentComments.remove(docID, commentID);
        } catch (e) {
            return rejectWithValue((e as AxiosError).response?.data);
        }
    }
);
